import SessionBase from './SessionBase';
import Main from './Main';
import Login from './Login';

const Session = ({ children }) => (
  <SessionBase
    fallback={false && <div>Connexion au serveur...</div>}
    loginComponent={Login}
  >
    <Main>{children}</Main>
  </SessionBase>
);

export default Session;
